@if (!item.deleted && !item.hidden && !!item.title && item.countDescendants !== 0) {
  <div
    class="d-flex pointer my-1"
    [style.padding-left.rem]="level"
    role="button">
    <div
      [class.invisible]="!hasVisibleItems()"
      tabindex="0"
      (keyup.enter)="toggleCollapsed()"
      (click)="toggleCollapsed()">
      <span
        class="text-muted expand-icon material-symbols-outlined"
        aria-hidden="true">{{ collapsed ? 'chevron_right' : 'expand_more' }}</span>
    </div>
    @if (!item.unselectable) {
      <div
        class="form-check mb-1"
      >
        <label class="form-check-label">
          <input
            class="form-check-input float-none me-1"
            type="checkbox"
            (change)="toggle()"
            [checked]="selected">
          {{ item.title }}
          <app-tree-item-badge
            [item]="item"
            [visible]="showCount"/>
        </label>
      </div>
    }
    @if (item.unselectable) {
      <div
        class="form-label"
      >
        {{ item.title }}
        <app-tree-item-badge
          [item]="item"
          [visible]="showCount"/>
      </div>
    }
  </div>
  @for (item of item.items; track item) {
    <div>
      <app-tree-item
        [item]="item"
        [hidden]="collapsed"
        [level]="level + 1"
        [selectedItems]="selectedItems"
        [showCount]="showCount"
        (selectItem)="selectItem.emit($event)"
        (deselectItem)="deselectItem.emit($event)"/>
    </div>
  }
}
